import { render, staticRenderFns } from "./DescriptionOfPublicTender.vue?vue&type=template&id=938ad726&scoped=true&"
import script from "./DescriptionOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./DescriptionOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionOfPublicTender.vue?vue&type=style&index=0&id=938ad726&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938ad726",
  null
  
)

export default component.exports